export const ALCANTARA = 1058;
export const CLOTH = 1055;
export const LEATHER = 1056;
export const PART_LEATHER = 1057;
export const SYNTHETIC_LEATHER = 8101;
export const PLASTIC = 8102;
export const VELOUR = 8103;
export const OTHER = 8104;
